const getUser = ({ user, payments, site }) => {
  if (user) {
    const isUserPayment = payment => payment.email === user.email;
    const userPayments = payments && payments.filter(isUserPayment);
    const admin = site && site.find(record => record.id === 'admin');
    const isAdmin = admin && admin.users.includes(user.email);
    return {
      ...user,
      payments: userPayments,
      isAdmin,
    };
  }
  return null;
};

export default {
  isAdmin: state => state.mode === 'admin',
  getUser: state => getUser(state),
};
